import * as Models from "../../../Models";
import * as Services from "../../../Services";
import * as Routes from "../../../Routes";
import * as Common from "../../../Common/modules";
import * as toastr from "toastr";
import * as _ from "lodash";

    export interface IResendInvoiceModalScope extends ng.IScope {
        resendInvoiceModalCtrl: ResendInvoiceModalCtrl;
    }

    export class ResendInvoiceModalCtrl {

        public invoice: Models.Customer.InvoiceDetailBaseResponse.InvoiceDetailBaseResponse;
        public resendInvoiceRequest: Models.Customer.ResendInvoiceRequest.IResendInvoiceRequest;
        public invoiceEmail: Models.Customer.ResendInvoiceRequest.ResendInvoiceEmail;
        public newEmailId = 0;
        public prefersPaperInvoices: boolean;

        public static $inject = ['$scope', '$modalInstance', 'InvoiceApiClient', 'passedInInvoice', 'passedInEmail', 'passedInPrefersPaperInvoices'];

        constructor(public $scope: IResendInvoiceModalScope,
            public $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
            private invoiceApiClient: Services.InvoiceApiClient.IInvoiceApiClient,
            public passedInInvoice: Models.Customer.InvoiceDetailBaseResponse.InvoiceDetailBaseResponse,
            public passedInEmail: Models.Customer.ResendInvoiceRequest.ResendInvoiceRequest,
            public passedInPrefersPaperInvoices: boolean) {

            $scope.resendInvoiceModalCtrl = this;
            this.invoice = passedInInvoice;
            this.resendInvoiceRequest = passedInEmail;
            this.prefersPaperInvoices = passedInPrefersPaperInvoices;
        }

        public close = () => {
            this.$modalInstance.dismiss();
        }

        public resend = () => {
            this.resendInvoiceRequest.invoiceNumber = this.invoice.invoiceNumber;
            this.invoiceApiClient.resendInvoice(this.resendInvoiceRequest).then(() => {
                toastr.success('Invoice has been re-sent');
                this.$modalInstance.dismiss();
            }, () => {
                toastr.error('ERROR');
            });
        }

        public addEmail = () => {
            var newEmail = new Models.Customer.ResendInvoiceRequest.ResendInvoiceEmail();
            newEmail.emailAddressId = this.newEmailId;
            this.newEmailId--;

            this.resendInvoiceRequest.emailAddresses.push(newEmail);
        }

        public removeEmail = (emailAddressId: number): void => {
            _.forEach(this.resendInvoiceRequest.emailAddresses,
                (email) => {
                    if (email.emailAddressId === emailAddressId) {
                        _.remove(this.resendInvoiceRequest.emailAddresses,
                            {
                                emailAddressId: emailAddressId
                            });
                    }
                });
        }
    }